var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[(_vm.$can('update_deals'))?[_c('a',{attrs:{"href":_vm.route('deal_details.page', {id: _vm.rowData.id})},on:{"click":function($event){return _vm.stopParentEvent($event)}}},[_vm._v("\n            "+_vm._s(_vm.rowData.title)+"\n        ")])]:[_c('span',[_vm._v(_vm._s(_vm.rowData.title))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }